import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import { getInvoiceTaxAuthorityConfigById } from 'Services/invoices';
import useUpdateInvoiceTaxAuthorityConfig from 'Hooks/useUpdateInvoiceTaxAuthorityConfig';
import useWorkspaceSelected from 'Hooks/useWorkspaceSelected';
import Loading from 'Components/Atoms/Loading/Loading';
import InvoicesTaxAuthorityConfigVerifactuForm from './InvoicesTaxAuthorityConfigVerifactuForm';
import InvoicesTaxAuthorityConfigTicketbaiForm from './InvoicesTaxAuthorityConfigTicketbaiForm';

function getVerifactuDefaultValues(config) {
    return {
        country: config.country ?? 'ESP',
        invoice_subtype: config.invoice_subtype ?? null,
        contact_type: config.contact_type ?? null,
        contact_id: config.contact_id ?? null,
        es_verifactu_doc_type: config.es_verifactu_doc_type ?? null,
        simplified_art7273_bool: config.es_verifactu_simplified_art7273 === 'Y',
        es_verifactu_issuer_type: config.es_verifactu_issuer_type ?? null,
        representative_name: config.representative_name ?? null,
        representative_tax_id: config.representative_tax_id ?? null,
        representative_country: config.representative_country ?? 'ESP',
        es_verifactu_regime: config.es_verifactu_regime ?? '01',
    };
}

function getTicketbaiDefaultValues(config) {
    return {
        country: config.country ?? 'ESP',
        invoice_subtype: config.invoice_subtype ?? null,
        contact_type: config.contact_type ?? null,
        contact_id: config.contact_id ?? null,
        es_tbai_doc_type: config.es_tbai_doc_type ?? null,
        es_tbai_issuer_type: config.es_tbai_issuer_type ?? null,
        es_tbai_regime: config.es_tbai_regime ?? '01',
    };
}

export default function InvoicesTaxAuthorityConfigEditDrawer({ configId, onClose, onSubmit, onError }) {
    const { data: config, isLoading } = useQuery({
        queryKey: ['invoices', 'tax-authority-configs', configId],
        queryFn: () => getInvoiceTaxAuthorityConfigById(configId),
        enabled: !!configId,
    });

    const { updateConfig } = useUpdateInvoiceTaxAuthorityConfig();
    const { workspace } = useWorkspaceSelected();

    if (isLoading || !config) {
        return (
            <div className="flex justify-center py-12">
                <Loading />
            </div>
        );
    }

    const formProps = {
        onSave: (params) => updateConfig({ configId: config.id, params }),
        onClose,
        onSuccess: onSubmit,
        onError,
    };

    if (workspace?.tax_authority === 'ticketbai') {
        return <InvoicesTaxAuthorityConfigTicketbaiForm defaultValues={getTicketbaiDefaultValues(config)} {...formProps} />;
    }

    return <InvoicesTaxAuthorityConfigVerifactuForm defaultValues={getVerifactuDefaultValues(config)} {...formProps} />;
}

InvoicesTaxAuthorityConfigEditDrawer.propTypes = {
    configId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};
